<script>
import RouterLinkSpa from './RouterLinkSpa'
import RouterLinkHref from './RouterLinkHref'

export default {
  props: {
    to: {
      type: [String, Object]
    },
    tag: {
      type: String
    },
    'active-class': {
      type: String,
      default: 'router-link-active'
    },
    condition: {
      type: Boolean,
      default: true
    },
    target: {
      type: String,
      default: '_self'
    },
    domain: {
      type: String,
      default: ''
    },
    shouldAddCountryPath: {
      type: Boolean,
      default: false
    }
  },
  render(createElement, context) {
    const path = this.shouldAddCountryPath ? `${this.countryPath}${this.to}` : this.to
    if (this.canUseRoute && this.condition && this.$route.path != this.to) {
      return createElement(
        RouterLinkSpa,
        {
          props: {
            to: path,
            tag: this.tag,
            'active-class': this.activeClass,
            target: this.target
          }
        },
        this.$slots.default
      )
    } else {
      return createElement(
        RouterLinkHref,
        {
          props: {
            to: `${this.domain}${path}`,
            tag: this.tag,
            'active-class': this.activeClass,
            target: this.target
          }
        },
        this.$slots.default
      )
    }
  }
}
</script>
